import addRoute from '@/router/add-route';

const Settings = () => import('@/modules/settings/settings.vue');

const settings = [
    addRoute({
        name: 'settings',
        path: '/settings',
        component: Settings,
    }),
];

export default settings;
